import React from 'react'
import CivilCase from './CivilCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

export default function CivilCases({ data }: { data: any }) {
  const theme = useTheme()
  const cases = data?.court_case_info?.civil ?? []
  const caseCount = cases.length

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        民事案件
      </Text>
      <Stack gap="sm" className="mt-3">
        <ExpandableListWrapper isEmpty={caseCount === 0}>
          {cases.map((item: any, index: number) => (
            <CivilCase number={index + 1} key={index} item={item} />
          ))}
        </ExpandableListWrapper>
      </Stack>
    </div>
  )
}
